import firebase from '@firebase/app'
import '@firebase/firestore'
import 'firebase/auth'

const config = {
  apiKey: 'AIzaSyAayIykb5va9FnsfnSVF5Jv-1u12-nuRzc',
  authDomain: 'ehtkollen-1d52b.firebaseapp.com',
  projectId: 'ehtkollen-1d52b',
  storageBucket: 'ehtkollen-1d52b.appspot.com',
  messagingSenderId: '880405914978',
  appId: '1:880405914978:web:7896bcfdade9dd20da383b'
  // databaseURL: 'https://ehtkollen-1d52b.firebaseio.com',
}
var firebaseConfig = {

}
const settings = {
  timestampsInSnapshots: true
}

firebase.initializeApp(config)
const db = firebase.firestore()
db.settings(settings)

export default db
export { firebase }
